import { render } from "./ProductividadOperario.vue?vue&type=template&id=6af3a3f4"
import script from "./ProductividadOperario.vue?vue&type=script&lang=js"
export * from "./ProductividadOperario.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__